<template>
  <div class="notifications">
    <template v-if="notifications.results">
      <template v-if="notifications.count">
        <ul class="navbar mark-read">
          <li>
            <a
              @click="markAllAsRead"
            >
              Mark All As Read
            </a>
          </li>
        </ul>

        <div class="notifications-list">
          <notification
            v-for="notification of notifications.results"
            :key="`notification-${notification.thread}`"
            :notification="notification"
            @deleted="removeNotification(notification)"
          />
        </div>
      </template>
      <div
        v-else
        class="no-notifications"
      >
        You have no notifications.
      </div>
    </template>
    <div
      v-else
      class="not-loaded"
    >
      <spinner
        v-if="notifications.loading"
        preset="large"
      />
      <template v-else-if="notifications.error">
        <div
          class="alert alert-danger"
          role="alert"
        >
          An error occurred while trying to load your notifications. Please check
          your connection and try again.
        </div>

        <button
          type="button"
          class="btn btn-outline-primary"
          @click="loadNotifications"
        >
          Try Again
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import Notification from '@/components/Notification.vue';

export default {
  components: {
    Notification,
  },
  data() {
    return {
      notifications: { loading: true },
    };
  },
  created() {
    this.loadNotifications();
    this.notificationEventHandler = () => {
      this.loadNotifications();
    };
    this.$root.$on('ws:notification', this.notificationEventHandler);
  },
  destroyed() {
    this.$root.$off('ws:notification', this.notificationEventHandler);
  },
  methods: {
    async loadNotifications() {
      this.notifications = { loading: true };

      const response = await this.api({
        url: 'notifications/threads/',
      });

      if (response.status === 200) {
        this.notifications = {
          results: response.body,
          count: response.body.length,
        };
      }
    },
    async removeNotification(n) {
      const idx = this.notifications.results.indexOf(n);
      if (idx > -1) {
        this.notifications.results.splice(idx, 1);
        this.notifications.count = this.notifications.results.reduce((a, b) => a + b.count, 0);
        this.$root.$emit('ws:notification:count', this.notifications.count);
      }
    },
    async markAllAsRead() {
      await this.api({
        url: 'notifications/threads/',
        method: 'DELETE',
      });
      this.notifications.results.length = 0;
      this.notifications.count = 0;
      this.$root.$emit('ws:notification:count', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-notifications {
    text-align: center;
  }
  .mark-read {
    margin: 0;
    color: var(--blue);
    cursor: pointer;
  }
  .notifications {
    border: 1px solid var(--gray);
  }
</style>
